import type { FaireProductEntity } from "../../entity_types/product";

export const p_rubhhs2set: FaireProductEntity = {
  token: "p_rubhhs2set",
  type: "product",
  name: "Gameday Rhinestone Pave Paw Print Dangle Earrings",
  brandToken: "b_vswk7rntc2",
  brandName: "SP Sophia Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/324335bda09825fe413564bc397bd18414f116bfa8904837deb15ad5c6d7c84c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c2cb57b91cc296f66c8b0dfa1d1a1b570c4d7892c68beab9b30f034ffbe4db3.jpeg",
    "https://cdn.faire.com/fastly/e7a84425b438bd43ecadc776ba9243ab6fb583eb35919de7fd8febe783493aff.jpeg",
    "https://cdn.faire.com/fastly/85c5aaccc235740fba815ad2cb175dd27155decd21eb64fe8fa8e26c3b5e3d2d.jpeg",
    "https://cdn.faire.com/fastly/7628ea5f16ed501602f166d307d00f1b02cf2d877c78f2a05ab88f9cf9c50623.jpeg",
    "https://cdn.faire.com/fastly/80f4aa87f9794fcc4c908dadc4b3f073443d48a52a625b060653f2963f05c7c1.jpeg",
    "https://cdn.faire.com/fastly/d87978a5c617f498346e82aa3777311d0200f04bc25d742cebfd9fb7108c6820.jpeg",
  ],
  priceDollars: 4.57,
  description:
    'Measurements:\nHeight: 2.4"\nWidth: 1.6"\n\nShow your team pride and love for pets with these Gameday Rhinestone Pave Faux Suede Paw Print Dangle Earrings. Designed with a soft faux suede base and sparkling rhinestone embellishments, these lightweight earrings make a bold statement without sacrificing comfort. The playful paw print motif adds a spirited, supportive touch—perfect for both school events and animal lovers alike.\n\nPerfect For:\nGame day outfits, school spirit week, pep rallies, tailgates, fundraisers, family nights, and cheering from the sidelines. A fun and fashionable accessory for students, cheerleaders, pet moms, teachers, alumni, animal advocates, and fans looking to stand out in the crowd.',
  tags: [],
  msrpDollars: 18.29,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:20.353Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
